export default __webpack_public_path__ + "static/media/tesla.6d8fccf4.webp";